import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React from 'react';
import DefaultSettings from './settings';
// import AssessmentIcon from '@material-ui/icons/Assessment';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         // "& .MuiTypography-body1": {
//         //     //color: 'rgba(0, 0, 0, 0.54)',
//         //     fontSize: 12,
//         //     fontWeight: 'bold'
//         // },
//         "& .MuiSvgIcon-root": {
//             height: '1 rem'
//         },


//     }
// }));


const defaults = {
    transformProps: {
        label: 'Name',
        value: 'Value'
    }
}

export default function CheckBox(props) {
    const { value, handleFieldValue, extraProps, shareProps, tooltip, contexthelp, required, className, disabled, error, ...otherProps } = props
    const { name, label, helperText, items, fullWidth, ...hiddenProps } = otherProps
    let { transformProps } = extraProps || {}
    transformProps = transformProps || defaults.transformProps
    let selecteditem = []
    let fieldval = (value === 'Y' || value === true) ? true : false;
    let fieldname = value ? (transformProps ? transformProps[value] : value) : false
    if (items && items.length > 0) {
        selecteditem = items && (items || []).filter((each) => {
            return (each[transformProps.value]) === value
        })
        fieldval = selecteditem && selecteditem.length > 0 && selecteditem[0].value || 'N'
        fieldname = selecteditem && selecteditem.length > 0 && selecteditem[0].name || false
    }
    // const classes = useStyles();
    // let tlabel = (tooltip || contexthelp) ? <Typography variant='h6' style={{ color: props.errors ? 'red' : disabled ? disabled : 'black' }}> {label}&nbsp;    {required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''} < Tooltip title={tooltip ? tooltip : null} placement="bottom-start" >
    //     <HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: '#007bff' }} onClick={(evt) => contexthelp ?
    //         DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    // </Tooltip> </Typography> : <Typography variant='caption'>{label}</Typography>;

    let tlabel = <Typography variant='caption' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
    {tooltip && <Tooltip title={tooltip ? tooltip : null}
        placement="bottom-start" >
        <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
            onClick={(evt) => contexthelp ?
                DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    </Tooltip>}
  </Typography>
    return (
        <Box className={className}>
            <FormControl fullWidth={fullWidth ? fullWidth : false} error={error} >
                <FormGroup >
                    <FormControlLabel
                        control={<Checkbox
                            value={fieldval}
                            checked={selecteditem && selecteditem.length > 0 ? (fieldname === 'true' || ((fieldname === 'Yes') ? true : false)) :
                                (fieldname || ((fieldval === "N" || fieldval === false) ? false : true))}
                            onChange={(evt) => {
                                handleFieldValue({ target: { value: evt.target.value, name: name, checked: evt.target.checked }, currentTarget: { dataset: null } })
                            }}
                            name={name}
                            color={disabled ? '' : 'primary'}
                        />
                        }
                        style={{
                            fontSize: 12
                        }}
                        label={tlabel}
                        disabled={disabled}
                        {...hiddenProps}
                    />
                </FormGroup >
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        </Box>
    )
}